
/*
==================================================
TAKASO CUSTOM START｜課題07
変更日：2026-10-17
目的：オンライン講座と通常商品の混合カートを禁止
判定：商品タグ「オンライン講座」
対象：Prestige 10.5.1 の商品追加フォーム
==================================================
*/

(() => {
  "use strict";

  const COURSE_TAG = "オンライン講座";
  const MESSAGE =
    "オンライン講座と通常商品は同時にご購入いただけません。お手数ですが、別々にご注文ください。";

  const root = () => window.Shopify?.routes?.root || "/";

  const endpoint = (path) => `${root()}${path}`;

  function showError(form, message) {
    const buyButtons = form.querySelector("buy-buttons");
    const target = buyButtons || form;

    target.querySelector(".takaso-cart-separation-error")?.remove();

    const banner = document.createElement("div");
    banner.className =
      "banner banner--error takaso-cart-separation-error";
    banner.setAttribute("role", "alert");
    banner.textContent = message;

    target.prepend(banner);
    banner.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  }

  async function getCart() {
    const response = await fetch(endpoint("cart.js"), {
      credentials: "same-origin",
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error("カート情報を取得できませんでした。");
    }

    return response.json();
  }

  async function isCourseProduct(productHandle) {
    const response = await fetch(
      endpoint(`products/${encodeURIComponent(productHandle)}.js`),
      {
        credentials: "same-origin"
      }
    );

    if (!response.ok) {
      throw new Error("商品情報を取得できませんでした。");
    }

    const product = await response.json();

    return Array.isArray(product.tags)
      ? product.tags.includes(COURSE_TAG)
      : false;
  }

  async function getCartType(cart) {
    if (!cart.items || cart.items.length === 0) {
      return "empty";
    }

    const types = await Promise.all(
      cart.items.map(async (item) => {
        if (!item.handle) {
          throw new Error("商品情報を確認できませんでした。");
        }

        return isCourseProduct(item.handle);
      })
    );

    const hasCourse = types.some(Boolean);
    const hasNormal = types.some((value) => !value);

    if (hasCourse && hasNormal) {
      return "mixed";
    }

    return hasCourse ? "course" : "normal";
  }

  function getAddingProductType(form) {
    const productForm = form.closest("product-form");

    if (!productForm) {
      return null;
    }

    const value = productForm.dataset.takasoCourse;

    if (value === "true") {
      return "course";
    }

    if (value === "false") {
      return "normal";
    }

    return null;
  }

  let checking = false;

  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      if (!form.closest("product-form")) {
        return;
      }

      if (!form.querySelector('input[name="id"]')) {
        return;
      }

      // 再送信時には、同じ処理を繰り返さない。
      if (form.dataset.takasoValidated === "true") {
        delete form.dataset.takasoValidated;
        return;
      }

      // Prestige本体が処理する前に送信を一時停止。
      event.preventDefault();
      event.stopImmediatePropagation();

      if (checking) {
        return;
      }

      checking = true;

      const submitter = event.submitter;
      const addingType = getAddingProductType(form);

      try {
        if (!addingType) {
          throw new Error(
            "商品区分を確認できませんでした。ページを再読み込みしてください。"
          );
        }

        const cart = await getCart();
        const cartType = await getCartType(cart);

        if (cartType === "mixed") {
          showError(form, MESSAGE);
          return;
        }

        if (
          (cartType === "course" && addingType === "normal") ||
          (cartType === "normal" && addingType === "course")
        ) {
          showError(form, MESSAGE);
          return;
        }

        form.querySelector(".takaso-cart-separation-error")?.remove();

        // 問題がない場合、Prestige本来の商品追加処理へ戻す。
        form.dataset.takasoValidated = "true";

        if (typeof form.requestSubmit === "function") {
          if (submitter && submitter.isConnected) {
            form.requestSubmit(submitter);
          } else {
            form.requestSubmit();
          }
        } else {
          form.dispatchEvent(
            new Event("submit", {
              bubbles: true,
              cancelable: true
            })
          );
        }

      } catch (error) {
        console.error("[TAKASO] カート混合制限:", error);

        showError(
          form,
          "カートの確認ができませんでした。ページを再読み込みして、もう一度お試しください。"
        );

      } finally {
        checking = false;
      }
    },
    true
  );

})();

/*
==================================================
TAKASO CUSTOM END｜課題07
==================================================
*/
